import React from 'react';
import classNames from 'classnames/bind';

import PropTypes from 'prop-types';

// Components
import { Text, Link } from '@beef/ui-kit';
import { Picture } from 'components';
import { infoShape } from '../../propTypes';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const Header = ({
  isRoaming, title, roamingTitle, titleImageUrl, roamingTitleImageUrl, info,
}) => {
  const text = isRoaming ? roamingTitle : title;
  const image = isRoaming ? roamingTitleImageUrl : titleImageUrl;
  return (
    <>
      <div className={cn('header')}>
        <div className={cn('header__title')}>
          <Picture
            defaultImage={image}
            className={cn('header__icon')}
            alt=""
          />
          <Text
            color="grey95"
            size="size3-m"
            tagType="h2"
          >
            {text}
          </Text>
        </div>
        <div className={cn('header__info')}>
          {info?.text
          && (
            <Link
              href={info.link}
              color="grey50"
              isNoUnderline
            >
              {info.text}
            </Link>
        )}
        </div>
      </div>
    </>
  );
};

Header.propTypes = {
  isRoaming: PropTypes.string,
  title: PropTypes.string,
  roamingTitle: PropTypes.string,
  titleImageUrl: PropTypes.string,
  roamingTitleImageUrl: PropTypes.string,
  info: infoShape,
};

export { Header };
